"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
var _style = _interopRequireDefault(require("./style.css"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _useNavigation2 = _interopRequireDefault(require("../../useNavigation.js"));
var _Settings = require("../Settings");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports["default"] = function _default(props) {
  var mediatorProps = props.mediatorProps,
    isNetworkError = props.isNetworkError;
  var settings = _objectSpread(_objectSpread({}, _Settings.initialValues), mediatorProps);
  var mustTakeInOrder = settings.mustTakeInOrder,
    showTitleInTooltip = settings.showTitleInTooltip;
  var _useNavigation = (0, _useNavigation2["default"])(_objectSpread(_objectSpread({}, props), {}, {
      mustTakeInOrder: mustTakeInOrder
    })),
    navItems = _useNavigation.navItems,
    currentFlowProps = _useNavigation.currentFlowProps,
    isLoading = _useNavigation.isLoading;
  return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.DefaultPlayerSettingsContext.Provider, {
    value: {
      background: 'solidColor',
      backgroundColor: '#fff'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: isLoading
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].nav
  }, navItems.map(function (item) {
    var bubble = /*#__PURE__*/_react["default"].createElement("div", {
      key: item.handle,
      className: (0, _classnames2["default"])(_style["default"].item, _defineProperty(_defineProperty(_defineProperty({}, _style["default"].current, item.isCurrent), _style["default"].allowed, item.isAllowed), _style["default"]["new"], item.isNew)),
      onClick: item.setCurrent
    });
    return showTitleInTooltip ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: item.title
      })
    }, bubble) : bubble;
  })), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.Player, _extends({
    key: currentFlowProps.handle
  }, currentFlowProps, {
    isNetworkError: isNetworkError
  }))));
};